import React, { useEffect, useRef } from 'react';

interface ChatLayoutProps {
  header: React.ReactNode;
  children: React.ReactNode;
  composer: React.ReactNode;
}

/**
 * ChatLayout - Layout similaire à ChatGPT
 * - Header fixe en haut (TOUJOURS visible)
 * - Zone de messages scrollable au centre
 * - Composer fixe en bas (TOUJOURS visible)
 */
export const ChatLayout: React.FC<ChatLayoutProps> = ({ header, children, composer }) => {
  const headerRef = useRef<HTMLElement>(null);
  const footerRef = useRef<HTMLElement>(null);

  // Debug et forcer la visibilité
  useEffect(() => {
    if (headerRef.current) {
      const element = headerRef.current;
      element.style.setProperty('display', 'block', 'important');
      element.style.setProperty('visibility', 'visible', 'important');
      element.style.setProperty('opacity', '1', 'important');
      console.log('✅ Header rendered and forced visible');
    }
    
    if (footerRef.current) {
      const element = footerRef.current;
      element.style.setProperty('display', 'flex', 'important');
      element.style.setProperty('visibility', 'visible', 'important');
      element.style.setProperty('opacity', '1', 'important');
      element.style.setProperty('z-index', '10000', 'important');
      console.log('✅ Footer rendered and forced visible');
    }
  }, [header, composer]);

  return (
    <div 
      className="flex flex-col w-full bg-[rgb(var(--bg))]"
      style={{
        height: '100%',
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Header fixe en haut - TOUJOURS visible */}
      <header 
        ref={headerRef}
        className="flex-shrink-0 border-b border-[rgb(var(--border))] bg-[rgb(var(--bg))]"
        style={{
          position: 'relative',
          zIndex: 100,
          display: 'flex',
          alignItems: 'center',
          minHeight: '64px',
          height: '64px',
          width: '100%',
        }}
      >
        {header}
      </header>

      {/* Zone de messages scrollable - SEULEMENT cette zone scroll */}
      <main 
        className="flex-1 overflow-y-auto overflow-x-hidden"
        style={{
          minHeight: 0,
          flex: '1 1 auto',
        }}
      >
        <div className="max-w-3xl mx-auto w-full px-4 py-6">
          {children}
        </div>
      </main>

      {/* Composer fixe en bas - TOUJOURS visible */}
      <footer 
        ref={footerRef}
        className="flex-shrink-0 border-t border-[rgb(var(--border))] bg-[rgb(var(--bg))]"
        style={{
          position: 'relative',
          zIndex: 10000,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '120px',
          width: '100%',
        }}
      >
        <div className="max-w-3xl mx-auto w-full">
          {composer}
        </div>
      </footer>
    </div>
  );
};
